import React, { Component } from "react";
import { db } from "../../config/firebaseconfig";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as assessmentActionCreators from "../../redux/modules/assessment";
import * as manageEducatorsActionCreators from "../../redux/modules/manageEducators";
import { AssessmentDashboard } from "../../components";
import LoaderAssessmentDashboardContainer from "../../containers/Assessment/LoaderAssessmentDashboardContainer";
import has from "mout/object/has";
import fetchGroupUAs from "../../helpers/assessment/fetchGroupUAs";
import initializeManageEducators from "../../helpers/users/initializeManageEducators";
import computeGroupUA from "../../helpers/assessment/computeGroupUA";
import getGroupType from "../../helpers/assessment/getGroupType";
import setUserTurorialFlag from "../../helpers/users/setUserTurorialFlag";

// use these imports for testing
import districtAdmin from "../../helpers/users/testing/districtAdmin";
import teacherUser from "../../helpers/users/testing/teacherUser";
import studentUser from "../../helpers/users/testing/studentUser";
import {
  initializeAssessment,
  getAllNodes,
  getStudentUA
} from "../../helpers/assessment/assessmentDashboard";
import requestGroupUAUpdate from "../../helpers/assessment/requestGroupUAUpdate";
import guaNeedsUpdateQ from "../../helpers/assessment/guaNeedsUpdateQ";
import processGroupUAUpdate from "../../helpers/assessment/processGroupUAUpdate";

import { setIndicator } from '../../redux/modules/assessmentIndicator'
import getSchoolYear from '../../helpers/getSchoolYear'

import isLicensed from "../../helpers/users/licenses/isLicensed";
import LicenseDenied from '../../components/Users/Licenses/LicenseDenied';
import schoolYearDataIndicator from '../../helpers/schoolYearDataIndicator';
const queryString = require("query-string");

// Handles data and state for the main "Test Overview" view
// on the '/assessment/dashboard/' route
class AssessmentDashboardContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      init: true,
      modalIsOpen: true,
      afterTest: false,
      is_close: true,
      updatingGUA: false,
      updatePasswordModal: false,
    };
    this.selectGroupUA = this.selectGroupUA.bind(this);
    this.selectStudent = this.selectStudent.bind(this);
    this.closeModal = this.closeModal.bind(this);
    //this.schoolYearDataIndicator = this.schoolYearDataIndicator.bind(this);
    this.closeUpdatePasswordModal = this.closeUpdatePasswordModal.bind(this)
  }

  // Initializes assessment data
  initAssessment(assessmentId, studentId, districts, year) {
    const user = this.props.user || this.state.user
    const {
      assessmentInitialize,
      assessmentInitializeSuccess,
      assessmentInitializeError,
      location,
      history
    } = this.props;

    const { getGroupUA } = this;
    const { initTestSelector } = this;
    const { search } = location;
    const stateUpdaters = {
      loading: assessmentInitialize,
      success: assessmentInitializeSuccess,
      error: assessmentInitializeError,
      init: this.state.init
    };
    initializeAssessment(
      assessmentId,
      studentId,
      districts,
      user,
      search,
      stateUpdaters,
      history,
      getGroupUA.bind(this),
      year,
      initTestSelector.bind(this)
    );
  }

  // Gets groupUA information if needed. groupUA aggregates
  // the individual userAssessment data into groups (such as
  // all the students who belong to a class or a school).
  getGroupUA(user, assessmentId, selectedStudent, districts) {
    const {
      fetchingGroupUAs,
      fetchingGroupUAsSuccess,
      fetchingGroupUAsError,
      history,
      location,
    } = this.props;
    const actions = {
      fetching: fetchingGroupUAs,
      success: fetchingGroupUAsSuccess,
      error: fetchingGroupUAsError,
      push: history.push,
      //setIndicator: this.schoolYearDataIndicator.bind(this)
    };
    let selectedGroupUA;
    if (location.search) {
      const qs = queryString.parse(location.search);
      if (has(qs, "gua")) {
        selectedGroupUA = qs.gua;
      }
    }
    const districtData = this.props.districts || districts;
    fetchGroupUAs(
      user,
      assessmentId,
      actions,
      selectedGroupUA,
      null,
      null,
      districtData,
      selectedStudent,
    );

  }

  closeModal() {
    this.setState({ is_close: false });
  }

  closeUpdatePasswordModal = () => {
    this.setState({ updatePasswordModal: false })
  }

  // If a teacher with a username and no email,
  // prompt to go to My Profile and update email and password
  checkNeedPasswordUpdate = () => {
    const { user } = this.props
    if (!user) return
    if (!user.email && user.role === 'Teacher') {
      this.setState({ updatePasswordModal: true })
    }
  }

  initTestSelector(assessmentId, selectedStudent, selectedGroupUA){
    const { groupUAs, students, userLicenses, match } = this.props;
    const actions = {
      setIndicator: this.props.setIndicator
    }
    schoolYearDataIndicator(
      assessmentId, 
      selectedStudent, 
      selectedGroupUA,
      actions, 
      groupUAs, 
      students, 
      userLicenses, 
      match.params.assessmentId
      )
  }

  componentDidMount() {
    const {
      fetchingNodes,
      fetchingNodesSuccess,
      fetchingNodesError,
      districts,
      match,
      initializing,
      initializingError,
      initializingSuccess,
      setDistricts,
      setSchools,
      setEducators,
      setStudents,
      setClasses,
      selectedStudent,
    } = this.props;
    const assessmentId = match.params.assessmentId;
    // If user not from props, in devMode so use user specified in state.
    // this.props.setCurrentAssismentId(assessmentId)

    const user = this.props.user || this.state.user;
    this.setState({ init: false });
    if (user && user.role !== "Student" && selectedStudent !== "") {
      this.getGroupUA(user, assessmentId, selectedStudent, districts)
    }

    this.checkNeedPasswordUpdate()

    // Get all knowledge map nodes
    getAllNodes({
      loading: fetchingNodes,
      success: fetchingNodesSuccess,
      error: fetchingNodesError
    });


    // Initialize assessment. Need districts to do this, so if we don't
    // have them we go get them and then initialize assessment.
    if (districts || (user && user.role !== "Super Administrator")) {
      this.initAssessment(assessmentId);
    } else {
      db.collection("districts")
        .get()
        .then(querySnapshot => {
          let districts = {};
          querySnapshot.forEach(doc => {
            districts[doc.id] = doc.data();
          });
          this.initAssessment(assessmentId, null, districts);
        });
    }

    // Get groupData (account records, like schools, districts, teachers, etc.)
    // if user not student. Need this to make selector bar work.
    if (user && user.role !== "Student") {
      const initActions = {
        initializing: initializing,
        initializingError: initializingError,
        initializingSuccess: initializingSuccess,
        set: {
          districts: setDistricts,
          schools: setSchools,
          educators: setEducators,
          students: setStudents,
          classes: setClasses
        }
      };
      initializeManageEducators(user, initActions, match.params);
    }

    if (user) {
      db.collection("userVideoTurorial")
      .doc(user.id)
      .get()
      .then(doc => {
        let result = {
          is_first_video_show: false,
          is_afterTest_video_show: false
        };
        setTimeout(() => {
          this.setState({ init: true });
          localStorage.setItem("is_loader", 1);
        }, 1000);
        const data = doc.data();

        if (data !== undefined) {
          result = data;
        }

        this.setState({
          modalIsOpen: result.is_first_video_show,
          afterTest: result.is_afterTest_video_show
        });
        if (
          result.is_first_video_show === false &&
          result.is_afterTest_video_show === false
        ) {

          db.collection('userVideoTurorial').doc(user.id).set({ is_first_video_show: true, is_afterTest_video_show: false })
        }
      })
      .catch(err => console.log(err));
    }

    if (user.role === 'Student') {
      db.collection('students').doc(user.id).get()
        .then((student) => {
          this.initTestSelector(null, student.data())
        })
    }
  }



  componentWillReceiveProps(nextProps) {
    const user = this.props.user || this.state.user;
    const { fetchingGroupUAsSuccess, groupUAs, assessmentInitialize,
      assessmentInitializeSuccess,
      assessmentInitializeError, selectedYear, location } = this.props

    if (user.role === "Student" && nextProps.match.params.assessmentId !== this.props.match.params.assessmentId) {
      
      let year;
    // Parse the query string
    if (location.search) {
      const qs = queryString.parse(location.search);
      if(has(qs, 'y')) {
        year = qs.y
      } else {
        year = getSchoolYear().year
      }
    }
      getStudentUA(user, nextProps.match.params.assessmentId, {
        loading: assessmentInitialize,
        success: assessmentInitializeSuccess,
        error: assessmentInitializeError,
        //setIndicator: this.props.setIndicator
      }, year)
    }
    // If you are not a student, and so need group data and a groupUA,
    // once you receive the props you need to calculate a groupUA,
    // go ahead and compute it. A groupUA is an aggregation of userAssessments
    // all belonging to a specified group, such as a school, district, class, or
    // teacher.
    if (user.role !== "Student") {
      const { districts, schools, educators, classes } = this.props;

      const n = nextProps;
      const thisCheck = !!districts && !!schools && !!educators && !!classes;
      const nextCheck =
        !!n.districts && !!n.schools && !!n.educators && !!n.classes;
      if (thisCheck !== nextCheck && nextCheck) {
        // The groupUA id is specified in the query as 'gua'
        const groupUA = queryString.parse(n.location.search).gua;
        let year = queryString.parse(n.location.search).y;
        if (groupUA) {

          year = year ? year : getSchoolYear().year;
          const assessmentId = n.match.params.assessmentId
          if (groupUAs) {
            let groupUAObject
            if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
              groupUAObject = groupUAs[groupUA][year][assessmentId]
              //setTimeout(() => { this.schoolYearDataIndicator(null, null, groupUA); }, 100);
            }
            if (guaNeedsUpdateQ(groupUAObject) || !groupUAObject) {
              this.setState({ updatingGUA: true })
              let schoolYear = Number(year.split('sy')[1])
              requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
                .then(result => {
                  // let GUAs = groupUAs
                  // if (result) {
                  //   const GUA = JSON.parse(result)
                  //   GUAs = {
                  //     ...groupUAs,
                  //     [groupUA]: GUA,
                  //   }   
                  // }
                  // this.setState({updatingGUA: false})
                  // fetchingGroupUAsSuccess(GUAs)
                  const actions = {
                    fetchingGroupUAsSuccess,
                    updateState: this.setState.bind(this)
                  }
                  console.log(result)
                  processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)

                })
                .catch(err => {
                  console.log(err)
                  this.setState({ updatingGUA: false })
                })
            }
          }

        }
      }
    }
  }





  // Handle when educator selects a new groupUA.
  selectGroupUA(groupUA, year) {
    const {
      districts,
      schools,
      educators,
      classes,
      match,
      history,
      fetchingGroupUAsSuccess,
      groupUAs,
    } = this.props;
    // if you have the records you need, recompute the groupUA
    if (districts && schools && educators && classes) {
      const groupData = { districts, schools, educators, classes };
      const groupType = getGroupType(groupUA, groupData);
      const year = year ? year : getSchoolYear().year;
      const assessmentId = match.params.assessmentId;
      this.props.setUserAssessment(null)
      if (groupUAs) {
        let groupUAObject
        if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
          groupUAObject = groupUAs[groupUA][year][assessmentId]
          this.initTestSelector(null, null, groupUA)
        }
        if (guaNeedsUpdateQ(groupUAObject) || !groupUAObject) {
          this.setState({ updatingGUA: true })
          let schoolYear = Number(year.split('sy')[1])
          requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
            .then(result => {
              console.log(result)
              const actions = {
                fetchingGroupUAsSuccess,
                updateState: this.setState.bind(this)
              }
              processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)
            })
            .catch(err => {
              this.setState({ updatingGUA: false })
              console.log(err)
            })
        }
        this.props.setCompareGUAYear('');
      }
    }
    // go to the new URL
    //let queryParam = `?gua=${groupUA}`
    // if(this.props.isCompare)
    // {
    //   queryParam =`?gua=${groupUA}&compare_assisment=${this.props.compareAssismentId}`
    // }
    //this.resetCompareMode();
    //history.push(`${queryParam}`);
  }

  // Handle when educator selects a student
  selectStudent(studentId) {
    const { location, match, history } = this.props;
    // Add the new student id to the query with the key 's'
    const qs = queryString.parse(location.search);
    const newQs = {
      ...qs,
      s: studentId
    };

    const query = queryString.stringify(newQs);
    // Navigate to the new query
    history.push(`?${query}`);
    this.initAssessment(match.params.assessmentId, studentId);

    this.initTestSelector(null, studentId)
 
  }

  //when the school year is changed via HeaderActiveIndicator component.
  // relevent actions are performed based on values in selected option.
  componentDidUpdate(prevProps) {
    const { selectedYear, location, match, history, user, assessmentIndicator } = this.props;
    const { selectedOption } = assessmentIndicator;
    if (prevProps.assessmentIndicator.selectedOption !== selectedOption) {

      if (selectedOption) {
        const qs = queryString.parse(location.search)
        if (has(selectedOption, 'student') && qs.y) {
          this.initAssessment(selectedOption.testId, selectedOption.student, null, selectedOption.year)
        }
      }
    }
    if (prevProps.groupUAs !== this.props.groupUAs) {
      let selectedGroupUA;
      let selectedStudent;
      let assessmentId;
      if (location.search) {
        const qs = queryString.parse(location.search);
        if (has(qs, "s")) {
          selectedStudent = qs.s;
          assessmentId = this.props.userAssessment.assessmentSetId;
        } else if (has(qs, "gua")) {
          selectedGroupUA = qs.gua;
        }
      }
       this.initTestSelector(assessmentId, selectedStudent, selectedGroupUA);
    }
  }

  render() {
    const {
      userAssessment,
      userAssessmentCompare,
      nodes,
      groupUAs,
      is_computing_student_data,
      isFetchingGroupUAs,
      match,
      GUAFilter,
      assessmentInitializingError,
      location,
      manageEducatorsError,
      isInitializing,
      isFetchingNodes,
      districts,
      currentAssessmentId,
      schools,
      educators,
      classes,
      students,
      isAssessmentInitializing,
      compareAssismentId,
      isCompare,
      isSwap,
      compareGuaYear
    } = this.props;
    let test1 = this.props.currentAssismentName;
    let test2 = this.props.compareAssismentName;

    const { selectGroupUA, selectStudent, closeUpdatePasswordModal } = this;
    const user = this.props.user || this.state.user;
    const groupData = {
      districts,
      schools,
      educators,
      classes,
      students
    };
    const {
      modalIsOpen,
      afterTest,
      is_close,
      updatePasswordModal,
    } = this.state;
    const assessmentId = match.params.assessmentId;
    let selectedGroupUA = "";
    let selectedGroupUACompare = "";
    let selectedStudent = "";
    let groupUA = null;
    let groupUAComapre = null;
    let year;

    // Parse the query string
    if (location.search) {
      const qs = queryString.parse(location.search);
      if (has(qs, "gua")) {
        selectedGroupUA = qs.gua;
        selectedGroupUACompare = compareAssismentId;
      }
      if (has(qs, "s")) {
        selectedStudent = qs.s;
      }
      if(has(qs, 'y')) {
        year = qs.y
      } else {
        year = getSchoolYear().year
      }
    }

    // year = selectedYear ? selectedYear : getSchoolYear().year
    if (groupUAs) {
      if (has(this.props, `groupUAs.${selectedGroupUA}`)
        && assessmentId && has(groupUAs[selectedGroupUA], year)) {
        groupUA = groupUAs[selectedGroupUA][year][assessmentId];
      }
    }

    if (!selectedStudent && selectedGroupUACompare && compareAssismentId && compareGuaYear) {
      groupUAComapre = compareAssismentId ? groupUAs && groupUAs[selectedGroupUA] && 
      groupUAs[selectedGroupUA][compareGuaYear][compareAssismentId] : null
    }


    let is_initialized = false;
    if (this.state.init == true || localStorage.getItem("is_loader") == 1) {
      is_initialized = true;
    }

    return (is_initialized == true && !isAssessmentInitializing ?
      (isLicensed(assessmentId, this.props.userLicenses, user) ?
        <AssessmentDashboard
          modalIsOpen={modalIsOpen}
          isCompare={isCompare}
          is_close={is_close}
          afterTest={afterTest}
          userAssessment={userAssessment}
          userAssessmentCompare={userAssessmentCompare}
          nodes={nodes}
          groupUAs={groupUAs}
          groupUA={groupUA}
          groupUAComapre={groupUAComapre}
          isFetchingGroupUAs={isFetchingGroupUAs}
          selectedGroupUACompare={selectedGroupUACompare}
          currentAssessmentId={match.params.assessmentId}
          compareAssismentId={compareAssismentId}
          assessmentId={match.params.assessmentId}
          user={user}
          isSwap={isSwap}
          selectedGroupUA={selectedGroupUA}
          selectGroupUA={selectGroupUA}
          GUAFilter={GUAFilter}
          groupData={groupData}
          selectStudent={selectStudent}
          selectedStudent={selectedStudent}
          assessmentInitializingError={assessmentInitializingError}
          manageEducatorsError={manageEducatorsError}
          isInitializing={isInitializing}
          isFetchingNodes={isFetchingNodes}
          isAssessmentInitializing={isAssessmentInitializing}
          closeModal={this.closeModal}
          previousTest={year == getSchoolYear().year ? true : false}
          year={year ? year : getSchoolYear().year}
          updatingGUA={this.state.updatingGUA}
          init={this.state.init}
          test1={test1}
          test2={test2}
          compareGuaYear={compareGuaYear}
          userLicenses={this.props.userLicenses}
          updatePasswordModal={updatePasswordModal}
          closeUpdatePasswordModal={closeUpdatePasswordModal}
        /> : <LicenseDenied />)
      : <LoaderAssessmentDashboardContainer user={user}
        updatePasswordModal={updatePasswordModal}
        closeUpdatePasswordModal={closeUpdatePasswordModal}
      />
    );
  }
}

export default connect(
  state => ({
    isFetchingUserAssessment: state.assessment.isFetchingUserAssessment,
    user: state.users.testUser,
    userAssessment: state.assessment.userAssessment,
    userAssessmentCompare: state.assessment.compareAssismentData,
    nodes: state.assessment.nodes,
    groupUAs: state.assessment.groupUAs,
    isFetchingGroupUAs: state.assessment.isFetchingGroupUAs,
    selectedGroupUA: state.assessment.selectedGroupUA,
    GUAFilter: state.assessment.GUAFilter,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    assessmentInitializingError: state.assessment.assessmentInitializingError,
    manageEducatorsError: state.manageEducators.error,
    isInitializing: state.manageEducators.isInitializing,
    isFetchingNodes: state.assessment.isFetchingNodes,
    isAssessmentInitializing: state.assessment.isInitializing,
    isCompare: state.assessment.isCompare,
    compareAssismentId: state.assessment.compareAssismentId,
    compareAssismentData: state.assessment.compareAssismentData,
    isSwap: state.assessment.isSwap,
    selectedYear: state.users.selectedYear,
    assessmentIndicator: state.assessmentIndicator,
    compareGuaYear: state.assessment.compareGuaYear,
    currentAssismentName: state.assessment.currentAssismentName,
    compareAssismentName: state.assessment.compareAssismentName,
    userLicenses: state.licenses.userlicenses
  }),
  dispatch =>
    bindActionCreators(
      { ...assessmentActionCreators, ...manageEducatorsActionCreators, setIndicator },
      dispatch
    )
)(AssessmentDashboardContainer);



// WEBPACK FOOTER //
// ./src/containers/Assessment/AssessmentDashboardContainer.js